<div class="flex-align-items wrap g-10 bg-white rounded shadow p-2 m-b-20" id="default-fixed-menu">
  <div class="flex-align-items wrap g-10">
    <div class="block-site-selector">
      <label>{{ translate.instant('Cluster') }} </label>
      <ng-select
        (change)="selectCluster($event)"
        [addTag]="false"
        [clearable]="false"
        [closeOnSelect]="true"
        [compareWith]="compareCluster"
        [items]="clusters"
        [ngModel]="cluster"
        [notFoundText]="translate.instant('NoClusterFound')"
        [placeholder]="translate.instant('All')"
        [searchable]="true"
        bindLabel="name"
        class="selector select-site-selector"
        id="cluster"
      ></ng-select>
    </div>
  </div>
</div>
